<template>
    <img :src="corpImgBase64String"/>
</template>

<script>
import { corpImgBase64String } from '@/corpEnvironment.ts'

export default {
    computed: {
        corpImgBase64String() {
            return corpImgBase64String
        }
    }
}
</script>